import { Stack, Typography } from "@mui/material";

import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "../../UserContext";
import { ListMessages } from "./ListMessages";
import { ListNotifications } from "./ListNotifications";
import { ListRequests } from "./ListRequests";

import { ColorScheme } from "../../../Themes/ColorScheme";

export const MessageContent = () => {
	const { handleTitle } = useContext(UserContext);
	const { t } = useTranslation();

	useEffect(() => {
		handleTitle(t("common.messages"));
	}, []);

	return (
		<Stack
			sx={{ alignItems: "center", display: "flex", flex: 1 }}
			direction="column"
		>
			<ListNotifications />
			<ListRequests />
			<ListMessages />
		</Stack>
	);
};
